import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadQuote from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";
import { chain, DispatchLoadQuote } from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/SendMessage";

replaceInChain(chain, DispatchLoadQuote, props => {
    const newObj = { quoteId: props.parameter.quote.id, isMessageApi: true };
    props.dispatch(loadQuote(newObj));
});
